import { render, staticRenderFns } from "./QuestionnaireHeader.vue?vue&type=template&id=e08a90ba&scoped=true"
import script from "./QuestionnaireHeader.vue?vue&type=script&lang=js"
export * from "./QuestionnaireHeader.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireHeader.vue?vue&type=style&index=0&id=e08a90ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a90ba",
  null
  
)

export default component.exports